<ng-template #content></ng-template>
